
define('ssi/ssi',[],function(){

    return {
        load : function(name, req, onLoad, config) {
			// If this is a r.js building or a jsdom static page build or if this is a production page
			if(config.isBuild || window.jsdom || window.config.production) {
				onLoad('<!--# include virtual="/'+name.replace(/\/index$/, ".html")+'" -->');
			} else {
				require([name], function(func) {
					func(onLoad, window.config);
				});
			} 
        }
    };

});

define('ssi', ['ssi/ssi'], function (main) { return main; });
